<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">APHT Payment</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item to="/invoice-apht/created">
            <CIcon name="cil-credit-card" />
            Created
          </b-breadcrumb-item>
          <b-breadcrumb-item active>Memo</b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5 text-right mt-2">
        <CButton color="primary" class="ml-2" v-if="$helper.isRole($availRoles['Cabang'])" @click="$router.push({ name: 'Invoice APHT Add', params: { collateralId: $route.params.collateralId } })">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card">
      <CCardBody class="px-0 pb-0">
        <CRow class="mt-2">
          <CCol class="col-lg-7 col-xl-5 ml-5">
            <CForm>
              <b-input-group class="custom-input-group-white">
                <b-input-group-prepend class="custom-prepend-middle">
                  <b-form-select v-model="filter.filterType" :options="filter.options" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-form-select v-if="filter.filterType == 'memoStatus'" v-model="filter.filterValue" :options="filter.filterValueMemoStatusOptions" style="min-width: 206.5px;"></b-form-select>
                <b-form-input v-else-if="filter.filterType == 'invoiceMemoNo'" v-model="filter.filterValue" maxlength="50" autocomplete="off" placeholder="Search"></b-form-input>
                <b-form-input 
                  maxlength="50" v-else type="text" placeholder="Search" 
                  :value="filter.filterValue" @input="filter.filterValue = $helper.parseNumber($event)"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                ></b-form-input>
                <b-input-group-append>
                  <CButton size="sm" color="primary" type="submit" title="Filter Tabel" :disabled="!table.isLoaded" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onTableSortChanged"
            >
              <template #cell(invoiceMemoNo)="row">
                {{ $helper.showData(row.value, "string") }}
              </template>
              <template #cell(materaiFee)="row">
                Rp {{ $helper.showData(row.value, "number") }}
              </template>
              <template #cell(notaryFee)="row">
                Rp {{ $helper.showData(row.value, "number") }}
              </template>
              <template #cell(pnbpFee)="row">
                Rp {{ $helper.showData(row.value, "number") }}
              </template>
              <template #cell(memoStatus)="row">
                <CBadge v-if="row.value == 'OA'" color="secondary"> On Approval
                </CBadge>
                <CBadge v-else-if="row.value == 'AP'" color="success"> Approved
                </CBadge>
                <CBadge v-else-if="row.value == 'RJ'" color="danger"> Rejected
                </CBadge>
                <CBadge v-else-if="row.value == 'RV'" color="warning"> Need Revise
                </CBadge>
                <CBadge v-else color="secondary"> -
                </CBadge>
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="primary" title="Detail Kontrak" class="btn-icon mr-1 custom-button-action" @click="$router.push({ name: 'Invoice APHT Approved Memo Detail', params: { collateralId: $route.params.collateralId, invoiceMemoNo: row.item.invoiceMemoNo } })">
                  <b-icon icon="eye"></b-icon>
                </CButton>
              </template>
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" @limit-change="onTableLimitChange" @page-change="onTablePageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>
  </CContainer>
</template>


<script>
export default {
  name: 'InvoiceMemoList',
  data() {
    return {
      isDownloading: false,
      filter: {
        filterType: "invoiceMemoNo",
        filterValue: '',
        options: [
          { value:"invoiceMemoNo", text: "No. Memo" },
          { value:"materaiFee", text: "Biaya Materai" },
          { value:"notaryFee", text: "Biaya Notaris" },
          { value:"pnbpFee", text: "Biaya PNBP" },
          { value:"memoStatus", text: "Status" }
        ],
        filterValueMemoStatusOptions: [
          { value: "OA", text: "On Approval" },
          { value: "AP", text: "Approved" },
          { value: "RJ", text: "Rejected" },
          { value: "RV", text: "Need Revise" }
        ]
      },
      table: {
        isLoaded: false,
        // table fields mirrors returned object from server-side
        fields: [
          {key: "invoiceMemoNo", label: "No. Memo", sortable: true},
          {key: "materaiFee", label: "Biaya Materai", sortable: true},
          {key: "notaryFee", label: "Biaya Notaris", sortable: true},
          {key: "pnbpFee", label: "Biaya PNBP", sortable: true},
          {key: "memoStatus", label: "Status", sortable: true},
          {key: "action", label: "Aksi", sortable: false}
        ],
        items: [],
        sortBy: null,
        sortDesc: true,
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      }
    }
  },
  methods: {
    filterTable(event){
      event.preventDefault()
      
      this.getTableItems()
    },
    onChangeFilterType() {
      if (this.filter.filterType == "memoStatus") {
        this.filter.filterValue = "OA"
      }
      else{
        this.filter.filterValue = null
      }
    },

    // update table with server-side processing on change
    onTableLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      this.getTableItems()
    },
    onTablePageChange(newPage) {
      // only fetch data when roles apply
      this.getTableItems(newPage)
    },
    onTableSortChanged(ctx) {
      this.table.sortBy = ctx.sortBy
      this.table.sortDesc = ctx.sortDesc
      // only fetch data when roles apply
      this.getTableItems(this.table.currentPage)
    },
    // get paginated table contents from server-side
    getTableItems(page = 1) {
      // URL builder
      let getUrl = "/aphtPayment/getMemoByCollateral"
      let params = {}
      params['page'] = (page - 1)
      params['size'] = this.table.perPage
      if(!this.$helper.isEmpty(this.filter.filterType) && !this.$helper.isEmpty(this.filter.filterValue)) {
        params['filterType'] = this.filter.filterType
        params['filterValue'] = this.filter.filterValue
      }
      if(this.table.sortBy != null) {
        params['sortBy'] = this.table.sortBy
        params['asc'] = !this.table.sortDesc
      }
      params['collateralAphtId'] = this.$route.params.collateralId
      // only send axios request if role is valid
      if(this.$helper.isRole(this.$availRoles['Cabang']) || this.$helper.isRole(this.$availRoles['FIMS']) || this.$helper.isRole(this.$availRoles['HO'])){
        this.table.isLoaded = false
        this.$axios.get(getUrl, {params: params}).then(response => {
          if(response.status == 200){
            sessionStorage.setItem("filterMemoStatusType" + String(this.$route.params.collateralId), this.filter.filterType)
            sessionStorage.setItem("filterMemoStatusValue" + String(this.$route.params.collateralId), this.filter.filterValue)
            this.table.items = response.data.data.data
            this.table.totalRows = response.data.data.totalElements
            this.table.totalPages = response.data.data.totalPages
          }
          else{
            this.$helper.toastError(this, "Load Daftar Memo Gagal! " + (!this.$helper.isEmpty(response.data.reason) ? response.data.reason : ""))
          }
        })
        .catch(error => {
          if(!this.$helper.isEmpty(error.response)){
            this.$helper.toastError(this, "Load Daftar Memo Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : "Endpoint Not Found"))
          }
          else{
            this.$helper.toastError(this, "Load Daftar Memo Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
          }
        })
        .finally(() => {
          this.table.isLoaded = true
        })
      }
      else{
        this.$helper.toastError(this, "Access Denied! Mohon tunggu beberapa saat atau lakukan Login ulang")
      }
    }
  },
  computed: {
  },
  mounted() {
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterMemoStatusType" + String(this.$route.params.collateralId)))){
      this.filter.filterType = sessionStorage.getItem("filterMemoStatusType" + String(this.$route.params.collateralId))
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterMemoStatusValue" + String(this.$route.params.collateralId)))){
      this.filter.filterValue = sessionStorage.getItem("filterMemoStatusValue" + String(this.$route.params.collateralId))
    }
    // get table contents on page load
    this.getTableItems()
  },
  created() {
  }
}
</script>

<style>

</style>
